import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * Named typography-scale utilities from the design system (`@theme --text-*` in
 * src/styles/globals.css). tailwind-merge cannot infer that `text-section-heading` is a font-size
 * rather than a text-colour, so it is registered explicitly — otherwise `cn('text-sm', 'text-field-title')`
 * keeps both, and `cn('text-sub-heading', 'text-text-primary')` silently drops the size.
 */
const TYPOGRAPHY_SCALE = ["section-heading", "sub-heading", "field-title"] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [...TYPOGRAPHY_SCALE] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
